import React, { Component } from 'react';

import Dropzone from 'react-dropzone';
import { Icon } from '@polichat/flamboyant';
import { isMobile } from 'react-device-detect';
import { useGlotaT } from 'src/hooks/useGlotaTranslation';

import { DropContainer, UploadMessage } from './stylesV2';
import ShowPreview from '../dropzone/v2/FilePreview/ShowPreview';

class UploadV2Class extends Component {
  renderDragMessage = (isDragActive, isDragReject) => {
    const { translations } = this.props;
    const {
      clickToUploadText,
      orDragText,
      filesNotSupportedText,
      dropFilesHereText,
      filesText,
    } = translations;

    if (!isDragActive) {
      return (
        <UploadMessage>
          <Icon icon="poli-icon pi-upload-fill" />
          {isMobile ? (
            <div>
              <span className="noDrags">{clickToUploadText}</span>
            </div>
          ) : (
            <div>
              <span className="noDrags">{clickToUploadText}</span> {orDragText}
            </div>
          )}
        </UploadMessage>
      );
    }

    if (isDragReject) {
      return (
        <UploadMessage type="error">
          <Icon icon="poli-icon pi-upload-fill" />
          <div>
            {filesText} <span className="drags">{filesNotSupportedText}</span>
          </div>
        </UploadMessage>
      );
    }
    return (
      <UploadMessage type="success">
        <Icon icon="poli-icon pi-upload-fill" />
        <div>
          {dropFilesHereText}
        </div>
      </UploadMessage>
    );
  };

  render() {
    const { onUpload, onRejected, selectPreview, chatSelected, openFile } =
      this.props;
    return (
      <Dropzone
        accept="image/*, video/*, audio/*, application/*, message/*, model/*, text/*, windows/metafile, www/mime, xgl/movie, xgl/drawing, x-conference/x-cooltalk, x-music/x-midi, x-world/*"
        onDropAccepted={onUpload}
        onDropRejected={onRejected}
        maxSize={30000000} ///20MB
        noClick={selectPreview ? true : false}
      >
        {({
          getRootProps,
          getInputProps,
          open,
          isDragActive,
          isDragReject,
        }) => (
          <DropContainer
            {...getRootProps()}
            isDragActive={isDragActive}
            isDragReject={isDragReject}
            className={`dropUpload ${selectPreview ? 'border-0' : ''}`}
            style={
              selectPreview && {
                background: 'var(--secondary-background-color)',
              }
            }
          >
            <input {...getInputProps()} />
            {selectPreview?.id ? (
              <div className="wrapperShowPreview">
                <ShowPreview
                  open={open}
                  openFile={openFile}
                  selectPreview={selectPreview}
                  chatSelected={chatSelected}
                />
              </div>
            ) : (
              this.renderDragMessage(isDragActive, isDragReject)
            )}
          </DropContainer>
        )}
      </Dropzone>
    );
  }
}

// Componente wrapper funcional que usa hooks e passa traduções como props
function UploadV2(props) {
  // Traduções usando hooks
  const clickToUploadText = useGlotaT('spa.chat.upload.clickToUpload');
  const orDragText = useGlotaT('spa.chat.upload.orDrag');
  const filesNotSupportedText = useGlotaT('spa.chat.upload.filesNotSupported');
  const dropFilesHereText = useGlotaT('spa.chat.upload.dropFilesHere');
  const filesText = useGlotaT('spa.chat.upload.files');

  return (
    <UploadV2Class
      {...props}
      translations={{
        clickToUploadText,
        orDragText,
        filesNotSupportedText,
        dropFilesHereText,
        filesText,
      }}
    />
  );
}

export default UploadV2;
